import { FleekError } from './FleekError';

type UnauthorizedErrorOptions = {
  scopes?: string[];
};

export class UnauthorizedError extends FleekError<UnauthorizedErrorOptions> {
  public name = 'UnauthorizedError';

  toString = () => {
    if (this.data.scopes) {
      return `You are not authorized to access this resource because of missing permissions: ${this.data.scopes.join(', ')}.`;
    }

    return `You are not authorized to access this resource.`;
  };
}
